import { Redirect, Route, Switch } from 'react-router-dom';

// eslint-disable-next-line no-restricted-imports -- Root level import allowed
import { Toast } from '@opendoor/bricks/complex/Toast';
import { ConnectedRouter } from 'connected-react-router';
import { History } from 'history';

import AddressConfirmationPage from 'src/containers/sellerFlow/AddressConfirmationPage';
import FlowCompleteRequestListingAgentOffer from 'src/containers/sellerFlow/FlowCompleteRequestListingAgentOffer';
import ManualAddressEntryPageWithSellerInput, {
  ManualAddressEntryPage,
} from 'src/containers/sellerFlow/ManualAddressEntryPage';
import MissingUnitNumberPage from 'src/containers/sellerFlow/MissingUnitNumberPage';
import NovoFlowCompletePartner from 'src/containers/sellerFlow/NovoFlowCompletePartner';

import LoadOffer from '../components/LoadOffer';
import TrackJourneyPageView from '../components/TrackJourneyPageView';
import ErrorPage from '../containers/ErrorPage';
import ActiveListingDenialPage from '../containers/sellerFlow/ActiveListingDenialPage';
import FlowComplete from '../containers/sellerFlow/FlowComplete';
import FlowCreateLead from '../containers/sellerFlow/FlowCreateLead';
import FlowDeniedNovo from '../containers/sellerFlow/FlowDeniedNovo';
import FlowPage from '../containers/sellerFlow/FlowPage';
import FlowStart from '../containers/sellerFlow/FlowStart';
import { WEB_API_URL } from '../helpers/globals';
import { MetricsContextProvider } from '../helpers/MetricsContext';
import { errorPagePath, sellerFlowPagePath, sellerGlobalPagePath } from './pathBuilders';

const RedirectToStart = ({ match }) => (
  <Redirect to={sellerFlowPagePath({ token: match.params.leadToken, slug: '' })} />
);

function renderRoutes(history: History) {
  return (
    <ConnectedRouter history={history}>
      <div>
        <MetricsContextProvider>
          <Switch>
            <Route path={errorPagePath()} component={ErrorPage} />
            <Route
              exact={true}
              path="/seller-lead/address-manual"
              component={ManualAddressEntryPage}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({
                token: ':leadtoken',
                page: 'address-manual',
              })}
              component={ManualAddressEntryPageWithSellerInput}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({
                token: ':leadToken',
                page: 'last-step',
              })}
              component={LoadOffer}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({ token: ':leadtoken', page: 'address' })}
              component={MissingUnitNumberPage}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({ token: ':leadtoken', page: 'address-confirm' })}
              component={AddressConfirmationPage}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({ token: ':leadtoken', page: 'complete' })}
              component={FlowComplete}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({
                token: ':leadtoken',
                page: 'unavailable',
              })}
              component={FlowDeniedNovo}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({
                token: ':leadtoken',
                page: 'complete-partner',
              })}
              component={NovoFlowCompletePartner}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({
                token: ':leadtoken',
                page: 'schedule',
              })}
              render={() => {
                window.location.href = WEB_API_URL;
                return null;
              }}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({
                token: ':leadtoken',
                page: 'verifying-listing',
              })}
              component={ActiveListingDenialPage}
            />
            <Route
              exact={true}
              path={sellerGlobalPagePath({
                token: ':leadtoken',
                page: 'complete-listing-agent-request',
              })}
              component={FlowCompleteRequestListingAgentOffer}
            />
            <Route
              exact
              path={sellerFlowPagePath({
                token: ':leadToken',
                slug: '(preview|preview-account|preview-confirmation|preview-home-details|preview)',
              })}
              render={RedirectToStart}
            ></Route>

            <Route
              exact={true}
              path={sellerFlowPagePath({ token: ':leadToken', slug: '' })}
              component={FlowStart}
            />
            <Route
              exact={true}
              path={sellerFlowPagePath({ token: ':leadToken', slug: ':slug' })}
              component={FlowPage}
            />

            <Route path="/leads/new" component={FlowCreateLead} />
          </Switch>
        </MetricsContextProvider>
        <TrackJourneyPageView history={history} />
        {/* Toast should only be mounted once at the root */}
        <Toast />
      </div>
    </ConnectedRouter>
  );
}

export default renderRoutes;
